"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppFooterLink = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Link = require("./Link.js");
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["className"];
/**
 * TODO: Delete the `FooterLinkProps` type and just use `AppFooterLinkProps`.
 */

/**
 * AppFooterLink is used for navigation links within the AppFooter.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-app-appfooterlink--docs) |
 * [Encore site](https://encore.spotify.net/web/components/app-layout#appfooter) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AppFooterLink) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?node-id=262-127)
 */
var AppFooterLink = exports.AppFooterLink = /*#__PURE__*/_react["default"].forwardRef(function AppFooterLink(_ref, ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var rel = props.target && props.target === '_blank' ? 'noopener noreferrer' : undefined;
  return /*#__PURE__*/_react["default"].createElement(_Link.Link, Object.assign({
    className: (0, _classnames["default"])((0, _layoutTheme.textClass)('marginalBold'), className)
  }, props, {
    ref: ref,
    rel: rel
  }));
});